import ISlideData from '@app/types/data/slides/ISlideData';
import PowerPointPresentation from '@app/services/export/ppt/PowerPointPresentation';
import AppStoreModule from '@app/store/modules/AppStoreModule';
import { getModule as getStoreModule } from 'vuex-module-decorators';
import GlobalsStoreModule from '@app/store/modules/GlobalsStoreModule';
import { IAnyOperatingTime } from '@app/types/base/IOperatingTime';
import OperatingTimesUtil from '@app/utils/OperatingTimesUtil';

const appStore: AppStoreModule = getStoreModule(AppStoreModule);
const globalsStore: GlobalsStoreModule = getStoreModule(GlobalsStoreModule);

export default abstract class PowerPointSlideProcessor<D extends ISlideData> {
	protected presentation: PowerPointPresentation;

	protected slideData: D;

	public constructor(slideData: D, presentation: PowerPointPresentation) {
		this.presentation = presentation;
		this.slideData = slideData;
	}

	public getSlideIdsForSlideData(): string[] {
		const count = [...Array(this.getSlideCount() - 1).keys()];
		return [this.slideData.id, ...count.map(value => `${this.slideData.id}_${value + 1}`)];
	}

	public abstract processSlideData(): Promise<void>;

	protected getSlideCount(): number {
		return 1;
	}

	protected get localeCode(): string {
		return appStore.localeCode;
	}

	protected get i18n(): Record<string, string> {
		return globalsStore.i18n;
	}

	protected mapOperatingTimes(
		operatingTimes: IAnyOperatingTime[] | undefined,
		omitFullYearServices: boolean = false
	): string | undefined {
		return OperatingTimesUtil.mapOperatingTimes(operatingTimes, this.i18n, this.localeCode, omitFullYearServices);
	}

	protected mapMaintenanceTimes(operatingTimes: IAnyOperatingTime[] | undefined): string | undefined {
		return OperatingTimesUtil.mapMaintenanceTimes(operatingTimes, this.i18n, this.localeCode);
	}
}
